import React from 'react';
import { Stack } from '@mui/material';

import { FieldChange } from './FieldChange';
import { ConditionsFeesChanges } from '../../../types';

const formatContingencies = (value: string[] | null): string => {
  if (!value || value.length === 0) return '—';
  return value.join(', ');
};

interface ConditionsFeesRenderProps {
  changes: ConditionsFeesChanges;
}

export const ConditionsFeesRender = ({ changes }: ConditionsFeesRenderProps) => (
  <Stack gap="0.25rem">
    {changes.notes && (
      <FieldChange label="Notes" before={changes.notes.before || '—'} after={changes.notes.after || '—'} />
    )}

    {changes.contingencies && (
      <FieldChange
        label="Contingencies"
        before={formatContingencies(changes.contingencies.before)}
        after={formatContingencies(changes.contingencies.after)}
      />
    )}
  </Stack>
);
